import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { tabsClass } from './styles';
import { isLink } from '../utils/is';

var Link =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Link, _PureComponent);

  var _super = _createSuper2(Link);

  function Link() {
    _classCallCheck(this, Link);

    return _super.apply(this, arguments);
  }

  _createClass(Link, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          href = _this$props.href,
          className = _this$props.className,
          other = _objectWithoutProperties(_this$props, ["children", "href", "className"]);

      var mergeClass = classnames(className, tabsClass('link'));

      var props = _objectSpread2({
        className: mergeClass,
        href: href
      }, other);

      if (isLink(children)) {
        if (children.props.onClick) {
          props.onClick = function () {
            children.props.onClick();

            if (other.onClick) {
              other.onClick();
            }
          };
        }

        return (
          /*#__PURE__*/
          React.cloneElement(children, _objectSpread2({}, props))
        );
      }

      return (
        /*#__PURE__*/
        React.createElement("a", props, children)
      );
    }
  }]);

  return Link;
}(PureComponent);

Link.isTabLink = void 0;
Link.isTabLink = true;
export default Link;